export class Country {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly code: string,
    readonly currencyCode: string,
  ) {
  }
}
